import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';

import { DataGrid } from '@mui/x-data-grid';

//MRT Imports
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { MRT_Localization_FR } from 'material-react-table/locales/fr';

//Material UI Imports
import {
  Box,
  Typography,
} from '@mui/material';
import { useOrganizationSelect } from '../../../context/OrganizationSelectContext';

   


const VBO365Licenses = () => {

  const [VBO365Licenses, setVBO365Licenses] = useState([]);
    const { selectedOrganization } = useOrganizationSelect();
 
  const fetchVBO365Licenses = async () => {
      try {
            const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/vbo365/licenses`,
            {
              headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('token'),
              },
            }
            );
          let filteredData = response.data;
            if (selectedOrganization) {
            filteredData = response.data.filter(
              (item) => item.organizationDetails?.name === selectedOrganization
            );
            }
          setVBO365Licenses(filteredData);
      } catch (error) {
          console.error('Error fetching organizations:', error);
      }
  };

  

  useEffect(() => {
    fetchVBO365Licenses();
  }, [selectedOrganization]);

    const columns = useMemo(
      () => [
        {
          id: 'licenses', //id used to define `group` column
          columns: [
            {
              accessorFn: (row) => `${row.name}`, //accessorFn used to join multiple data into a single cell
              id: 'name', //id is still required when using accessorFn instead of accessorKey
              header: 'Nom',
              size: 250,
              Cell: ({ renderedCellValue, row }) => (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem',
                  }}
                >{renderedCellValue}
                </Box>
              ),
              filterVariant: 'autocomplete',
            },
            {
              accessorFn: (row) => row.organizationDetails.name, //convert date to UTF-8 format
              id: 'organizationName', //id is still required when using accessorFn instead of accessorKey
              header: 'Client',
              size: 250,
              Cell: ({ renderedCellValue, row }) => (
                  <Box
                      sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '1rem',
                      }}
                  >
                      {renderedCellValue}
                  </Box>
              ),
              filterVariant: 'autocomplete',
          },
          {
            accessorKey: 'total', //hey a simple column for once
            header: 'Total',
            size: 100,
          },
            {
              accessorKey: 'new', //hey a simple column for once
              header: 'Nouvelles licences',
              size: 100,
            },
 
        
          ]}
      ],
      [],
    );
    
  
    const table = useMaterialReactTable({
    localization: MRT_Localization_FR,
    enableGlobalFilter: true,
    enableColumnFilters: true,

      columns,
      data: VBO365Licenses ? VBO365Licenses : null, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
      enableColumnFilterModes: true,
      enableColumnOrdering: true,
      enableGrouping: true,
      enableColumnPinning: true,
      enableFacetedValues: true,
      initialState: {
        density:"compact",
        // showColumnFilters: true,
        // showGlobalFilter: true,
        columnPinning: {
          left: ['mrt-row-expand', 'mrt-row-select'],
          right: ['mrt-row-actions'],
        },
        pagination: {
          pageSize: 50,
        }
      },
      paginationDisplayMode: 'pages',
      positionToolbarAlertBanner: 'bottom',
      muiSearchTextFieldProps: {
        size: 'small',
        variant: 'outlined',
      },
      muiPaginationProps: {
        color: 'secondary',
        rowsPerPageOptions: [50, 100, 150],
        shape: 'rounded',
        variant: 'outlined',
      },
      renderDetailPanel: ({ row }) => (
        <Box
          sx={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-around',
        left: '30px',
        maxWidth: '1000px',
        position: 'sticky',
        width: '100%',
          }}
        >
          <Box sx={{ textAlign: 'center', width: '100%' }}>
        <DataGrid
          rows={row.original.associatedUsers.map((user, index) => ({
            id: index,
            name: user.name,
            last_backup: new Date(user.lastBackupDate).toLocaleString('fr-FR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
            }),
          }))}
          disableColumnResize
          density="compact"
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
          }
          columns={[
            { field: 'name', headerName: 'Nom', flex: 1 },
            { field: 'last_backup', headerName: 'Dernier backup', flex: 1 },
          ]}
          pageSize={5}
          rowsPerPageOptions={[5]}
          slotProps={{
            filterPanel: {
          filterFormProps: {
            logicOperatorInputProps: {
              variant: 'outlined',
              size: 'small',
            },
            columnInputProps: {
              variant: 'outlined',
              size: 'small',
              sx: { mt: 'auto' },
            },
            operatorInputProps: {
              variant: 'outlined',
              size: 'small',
              sx: { mt: 'auto' },
            },
            valueInputProps: {
              InputComponentProps: {
            variant: 'outlined',
            size: 'small',
              },
            },
          },
            },
          }}
        />
          </Box>
        </Box>
        // <Box
        //   sx={{
        //     alignItems: 'center',
        //     display: 'flex',
        //     justifyContent: 'space-around',
        //     left: '30px',
        //     maxWidth: '1000px',
        //     position: 'sticky',
        //     width: '100%',
        //   }}
        // >
        //   <Box sx={{ textAlign: 'center' }}>
        //     <Typography variant="h6">{row.original.accountName}</Typography>
        //     <Typography variant="h1">
        //     </Typography>
        //   </Box>
        //   <Box>
        //     {row.original.associatedUsers.map((user, index) => (
        //       <Box key={index} sx={{ marginBottom: '8px' }}>
        //         <Typography variant="body1">
        //           Name: {user.name}
        //         </Typography>
        //         <Typography variant="body2">
        //           Last Backup Date: {user.lastBackupDate}
        //         </Typography>
        //       </Box>
        //     ))}
        //     </Box>
        // </Box>
      ),
    });
  
  
    return (
      <Box>
        <Typography variant="h6" my={1}>
          Licences Veeam Backup Office 365
          </Typography>
        <MaterialReactTable table={table} />
      </Box>
    );
};

export default VBO365Licenses;
